import { render, staticRenderFns } from "./DenunciantesView.vue?vue&type=template&id=48ab13fa&scoped=true"
import script from "./DenunciantesView.vue?vue&type=script&lang=js"
export * from "./DenunciantesView.vue?vue&type=script&lang=js"
import style0 from "./DenunciantesView.vue?vue&type=style&index=0&id=48ab13fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab13fa",
  null
  
)

export default component.exports